
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import apiInstance from '../utils/apiInstance';
import '@fortawesome/fontawesome-free/css/all.min.css';
import Table from '../common/Table';

const MenuLinks = () => {

    const { _id } = useParams();
    const [sortedData, setSortedData] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);


    useEffect(() => {
        async function fetchData() {
            try {
                const response = await apiInstance.get(`/menuLinks/${_id}`);
                setData(response.data.menuLinks);
            } catch (error) {
                setError("An error occurred while fetching menu link...");
            } finally {
                setLoading(false);
            }
        }
        fetchData();
    }, [_id]);

    useEffect(() => {
        if (data && Array.isArray(data)) {
            const sorted = [...data].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
            setSortedData(sorted);
        }
    }, [data]);


    const filteredData = sortedData.filter(link =>
        link.menu_link.toLowerCase().includes(searchQuery.toLowerCase())
    );

    const options = ['S No.', 'Link url', 'Status'];

    if (error) return <div>{error}<br />Please try again after some time or check your internet connection.</div>;
    return (
        <>
            <Table
                menuLinks='menuLinks'
                heading='Menu Link'
                options={options}
                data={filteredData}
                searchQuery={searchQuery}
                setSearchQuery={setSearchQuery}
                loading={loading}
            />
            {loading && (
                <div className="loader" style={{ position: 'absolute', top: '50%', left: '59%', transform: 'translate(-50%, -50%)' }}>
                    <div className="spinner-border text-info" role="status" style={{ width: '50px', height: '50px' }}>
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            )}
        </>
    );
};

export default MenuLinks;